module.exports = __webpack_public_path__ + "static/teaching-510069a46000277b9666b8cf505aa564.svg";